import { Component, Input } from '@angular/core';
import { OverviewEndpointStat } from '../../models/overview.model';

@Component({
  selector: 'app-top-endpoints-card',
  standalone: false,
  templateUrl: './top-endpoints-card.html',
})
export class TopEndpointsCard {
  @Input({ required: true }) endpoints: OverviewEndpointStat[] = [];

  get rows() {
    return this.endpoints.map(e => ({ label: e.endpoint, value: e.requests }));
  }
}
